import {
    Component,
    input,
    ChangeDetectionStrategy,
    computed,
} from '@angular/core'
import { RouterModule } from '@angular/router'
import { injectCurrentUser } from '@mattrika/benefit-core'
import { NgIcon } from '@ng-icons/core'
import { NavigationGroup } from '../sidebar-admin-default/sidebar.model'

@Component({
    selector: 'app-sidebar-client',
    imports: [RouterModule, NgIcon],
    templateUrl: './sidebar-client.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './sidebar-client.component.css',
})
export class SidebarClientComponent {
    private readonly user = injectCurrentUser()

    isCollapsed = input(false)
    logoSrc = input('assets/images/logo_vendor.png')
    logoAlt = input('Benefit Logo')
    companyName = input('ABC Restaurant')
    navigationGroups = input<NavigationGroup[]>([])

    showLabel = computed(() => !this.isCollapsed())
    logoLink = computed(() =>
        this.user.isOwner() ? '/client-admin' : '/client/dashboard',
    )
}
